import {sendRequest} from "./Sender";

export const FinanceService = {
    GetList,
    Update,
    Delete
}

function GetList(params= {}, expand = ''){
    return sendRequest('receipt/get-list', 'GET', {...params}, true)
}

function Update(params) {
    return sendRequest('receipt/update', 'POST', {...params}, true)
}

function Delete(params) {
    return sendRequest('receipt/delete', 'POST', {...params}, true)
}

